export type UserAuthResponse = {
	id: string;
	token: string;
	tokenDurationInMins: number;
};

export const getUserAuthUrl = (baseUrl: string) =>
	`${baseUrl}/rest/internal/2/media/user/credentials`;
